module.exports = __webpack_public_path__ + "img/image-landscape.d5fd29b1.svg";